import React, { useEffect, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
// config file

/**
 * !PLEASE DO NOT REMOVE THE BELOW FIELDS
 * !THESE FIELDS WILL BE REPLACED IN THE BACKEND AS PER REQUIREMENT
 * @FacilityStaffs
 * @Facility Staffs
 * @facilityStaffs
 * @[{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"firstName","type":"text","placeholder":"First Name","label":"First Name","width":110,"addFormOrder":1,"editFormOrder":1,"header":"First Name","derivedValue":"firstName=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"id":"firstName","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":false,"field":"firstName","showOrHideFields":[],"fieldName":"firstName","mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}},{"name":"lastName","type":"text","placeholder":"Last Name","label":"Last Name","width":"130px","addFormOrder":7,"editFormOrder":7,"header":"Last Name","derivedValue":"lastName=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"lastName","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":false,"field":"lastName","showOrHideFields":[],"fieldName":"lastName","mobile":true,"displayInSettings":true},{"name":"name","type":"derivedFields","placeholder":"Name","label":"Name","width":"120px","addFormOrder":8,"editFormOrder":8,"stringType":"string","header":"Name","derivedValue":"name=firstName+lastName","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":["firstName","lastName"],"actionsNumber":[],"id":"name","displayinaddForm":false,"displayineditForm":false,"displayinregisterForm":false,"displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":true,"field":"name","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"email","type":"email","placeholder":"Email","label":"Email","width":"150px","addFormOrder":10,"editFormOrder":10,"header":"Email","derivedValue":"email=email=undefined","capitalizeTableText":false,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"email","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"email","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"facilities","type":"relateAutoComplete","placeholder":"Facilities","label":"Facilities","width":"150px","addFormOrder":13,"editFormOrder":13,"header":"Facilities","derivedValue":"facilities=facilities=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"facilities","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":"Facilities","searchField":"facilityName","fieldType":"relateAutoComplete","populteFields":[],"displayFields":[],"controllerName":"Facility","searchApi":"facilities","isMultiple":true,"textAlign":"Center","show":true,"field":"facilities","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"phoneNumber","type":"number","placeholder":"Phone Number","label":"Phone Number","width":"120px","addFormOrder":11,"editFormOrder":11,"header":"Phone Number","derivedValue":"phoneNumber=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"phoneNumber","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":true,"field":"phoneNumber","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"permissionedRole","type":"dropDown","placeholder":"Permissioned Role","label":"Permissioned Role","width":"130px","addFormOrder":12,"editFormOrder":12,"header":"Permissioned Role","derivedValue":"permissionedRole=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"permissionedRole","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"options":[{"label":"Admin","value":"Admin","color":"primary"},{"label":"Staff","value":"Staff","color":"primary"}],"fieldType":"dropDown","dependent":[],"textAlign":"Center","show":true,"field":"permissionedRole","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"createdByName","type":"Text","placeholder":"Created By","label":"Created By","width":120,"header":"Created By","id":"createdByName","displayinlist":"true","globalSearchField":"false","controllerId":1001,"fieldType":"Text","textAlign":"Center","show":true,"field":"createdByName","mobile":true,"filter":true,"displayInSettings":true},{"name":"updatedByName","type":"Text","placeholder":"Updated By","label":"Updated By","width":120,"header":"Updated By","id":"updatedByName","displayinlist":"true","fieldType":"Text","textAlign":"Center","show":true,"filter":true,"field":"updatedByName","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true}]
 * @[{"name":"firstName","type":"text","placeholder":"First Name","label":"First Name","width":110,"addFormOrder":1,"editFormOrder":1,"derivedValue":"firstName=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"id":"firstName","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"fieldName":"firstName","mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"},"isAddFormHidden":false,"isEditFormHidden":false},{"name":"lastName","type":"text","placeholder":"Last Name","label":"Last Name","width":"130px","addFormOrder":7,"editFormOrder":7,"derivedValue":"lastName=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"lastName","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"fieldName":"lastName","mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"email","type":"email","placeholder":"Email","label":"Email","width":"150px","addFormOrder":10,"editFormOrder":10,"derivedValue":"email=email=undefined","capitalizeTableText":false,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"email","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"facilities","type":"relateAutoComplete","placeholder":"Facilities","label":"Facilities","width":"150px","addFormOrder":13,"editFormOrder":13,"derivedValue":"facilities=facilities=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"facilities","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":"Facilities","searchField":"facilityName","fieldType":"relateAutoComplete","populteFields":[],"displayFields":[],"controllerName":"Facility","searchApi":"facilities","isMultiple":true,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"phoneNumber","type":"number","placeholder":"Phone Number","label":"Phone Number","width":"120px","addFormOrder":11,"editFormOrder":11,"derivedValue":"phoneNumber=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"phoneNumber","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"permissionedRole","type":"dropDown","placeholder":"Permissioned Role","label":"Permissioned Role","width":"130px","addFormOrder":12,"editFormOrder":12,"derivedValue":"permissionedRole=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"permissionedRole","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"options":[{"label":"Admin","value":"Admin","color":"primary"},{"label":"Staff","value":"Staff","color":"primary"}],"fieldType":"dropDown","dependent":[],"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true}]
 * @
 * @
 * @
 *
 *
 *
 */

const FacilityStaffs = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);
  const [loginRoleType, setLoginRole] = useState('');
  const [facilities, setFacilities] = useState();


  const query = new URLSearchParams(location.search);
  let loginData = JSON.parse(localStorage.getItem('loginCredentials'));
  const companyId = query.get('comapnyId');
  const params = useParams();
  useEffect(() => {
    getLoginRole()
    getFacilityData()
    let screenPermissions =
      RolePermissions.screenPermissions("Facility Staff");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
  }, []);




  const getFacilityData = async () => {
    let loginData = localStorage.getItem('loginCredentials');
    loginData = JSON.parse(loginData);
    console.log("loginData", loginData);
    const loginRole = loginData.role;
    const loginCompanyId = loginData.company_Id;
    let api = 'facilities';
    let url;

    if (loginRole === 'Super Admin') {
      url = `${api}?companyId=${companyId}`;
    } else {
      url = `${api}?companyId=${loginCompanyId}`;
    }

    try {
      const response = await fetchMethodRequest('GET', url);
      if (response) {
        console.log("response", response)
        const facilityNames = response.facilities.map(facility => {
          return { label: facility.facilityName, value: facility._id };
        });
        setFacilities(facilityNames);
      }
    } catch (err) {
      console.error(err);
      return err;
    }
  };


  const customFormDataSet = (values) => {
    if (values.facilities && values.facilities.length > 0) {
      values.facilities = values.facilities.map(obj => obj._id)
    }
    return values;
  }

  const customFormDataManuplate = (values) => {
    if (values.facilities && values.facilities.length > 0) {
      values.facilities = values.facilities.map(id => {
        let obj = facilities.find(obj => obj.value == id)
        return obj
      })
    }
    return values;
  }



  const getDerivedStateFromProps = (props, state) => {
    let storeData = store.getState();
    let languageData =
      storeData &&
        storeData.settingsData &&
        storeData.settingsData.settings &&
        storeData.settingsData.settings.languageTranslation
        ? storeData.settingsData.settings.languageTranslation
        : "";
    return { languageData: languageData };
  };
  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };

  const getLoginRole = async () => {
    let loginData = localStorage.getItem('loginCredentials');
    if (loginData) {
      loginData = JSON.parse(loginData);
      console.log("loginData", loginData)

      if (loginData && loginData.role && loginData.company_Id
      ) {
        await setLoginRole(loginData.role);
      }
    }
  }



  const customFun = (rowData) => {
    let loginData = localStorage.getItem('loginCredentials');
    loginData = JSON.parse(loginData);
    let arr = [];
    if (rowData && rowData.role) {
      if (rowData.role === loginData.role) {
        arr.push('edit');
      } else {
        arr.push('edit', 'delete');
      }
    }
    return arr
  }


  const getTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    let data = [
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "userName",
        type: "text",
        placeholder: "First Name",
        label: "First Name",
        width: 140,
        addFormOrder: 1,
        editFormOrder: 1,
        header: "Name",
        derivedValue: "firstName=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        id: "firstName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: true,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "userName",
        showOrHideFields: [],
        fieldName: "userName",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "lastName",
        type: "text",
        placeholder: "Last Name",
        label: "Last Name",
        width: "130px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Last Name",
        derivedValue: "lastName=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "lastName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: false,
        field: "lastName",
        showOrHideFields: [],
        fieldName: "lastName",
        mobile: true,
        displayInSettings: true,
      },
      {
        type: "email",
        placeholder: "Email",
        label: "Email",
        width: "150px",
        addFormOrder: 10,
        editFormOrder: 10,
        header: "Email",
        derivedValue: "email=email=undefined",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "email",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "email",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "phoneNumber",
        type: "text",
        placeholder: "Phone Number",
        label: "Phone Number",
        width: "120px",
        addFormOrder: 11,
        editFormOrder: 11,
        header: "Phone",
        derivedValue: "phoneNumber=undefined",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "phoneNumber",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        fieldName: "phone",
        field: "phone",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "permissionedRole",
        type: "dropDown",
        placeholder: "Permissioned Role",
        label: "Permissioned Role",
        width: "130px",
        addFormOrder: 12,
        editFormOrder: 12,
        header: "Permissioned Role",
        derivedValue: "permissionedRole=undefined",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "permissionedRole",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        options: [
          { label: "Admin", value: "Admin", color: "primary" },
          { label: "Staff", value: "Staff", color: "primary" },
        ],
        // fieldType: "dropDown",
        dependent: [],
        textAlign: "Center",
        show: true,
        field: "role",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        // show: loginRoleType && loginRoleType !== "Staff" ? true : false,
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        customFun: customFun,
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
    ];
    return data;
  };

  const getFormFields = () => {
    let statusTypes = [
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return [
      {
        name: "firstName",
        type: "text",
        placeholder: "First Name",
        label: "First Name",
        width: 110,
        addFormOrder: 1,
        editFormOrder: 1,
        derivedValue: "firstName=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        id: "firstName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: true,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        fieldName: "name",
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "lastName",
        type: "text",
        placeholder: "Last Name",
        label: "Last Name",
        width: "130px",
        addFormOrder: 7,
        editFormOrder: 7,
        derivedValue: "lastName=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "lastName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        fieldName: "lastName",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "email",
        type: "email",
        placeholder: "Email",
        label: "Email",
        width: "150px",
        addFormOrder: 7,
        editFormOrder: 7,
        derivedValue: "email=undefined",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "email",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "password",
        type: "password",
        placeholder: "PassWord",
        label: "Password",
        width: "150px",
        addFormOrder: 7,
        editFormOrder: 7,
        derivedValue: "password=undefined",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "email",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: true,
      },
      {
        name: "confirmPassword",
        type: "password",
        placeholder: "Confirm Password",
        label: "Confirm Password",
        width: "150px",
        addFormOrder: 8,
        editFormOrder: 8,
        derivedValue: "confirmPassword=undefined",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "confirmPassword",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: true,
      },
      // {
      //   name: "facilities",
      //   type: "relateAutoComplete",
      //   placeholder: "Facilities",
      //   label: "Facilities",
      //   width: "150px",
      //   addFormOrder: 13,
      //   editFormOrder: 13,
      //   derivedValue: "facilities=facilities=undefined",
      //   capitalizeTableText: false,
      //   sortable: false,
      //   isClickable: false,
      //   customCriteria: loginData.role === "Super Admin" ? [{ key: 'companyId', value: companyId, type: 'eq' }] : [],
      //   filter: false,
      //   actions: [],
      //   actionsNumber: [],
      //   id: "facilities",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   isFieldRequired: "true",
      //   required: false,
      //   displayOptionsInActions: false,
      //   globalSearchField: "false",
      //   controllerId: "Facilities",
      //   searchField: "facilityName",
      //   fieldType: "relateAutoComplete",
      //   populteFields: [],
      //   displayFields: [],
      //   controllerName: "Facility",
      //   searchApi: "facilities",
      //   isMultiple: true,
      //   show: true,
      //   showOrHideFields: [],
      //   mobile: true,
      //   displayInSettings: true,
      //   isAddFormHidden: false,
      //   isEditFormHidden: false,
      // },

      {
        name: "facilities",
        type: "dropDown",
        placeholder: "Facilities",
        label: "facilities",
        width: "130px",
        addFormOrder: 45,
        editFormOrder: 45,
        derivedValue: "facilities=facilities=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        customCriteria: loginData.role === "Super Admin" ? [{ key: 'companyId', value: companyId, type: 'eq' }] : [],
        id: "facilities",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        options: facilities,
        fieldType: "dropDown",
        dependent: [],
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        isMultiSelect: true
      },

      {
        name: "phone",
        type: "text",
        placeholder: "Phone Number",
        label: "Phone Number",
        width: "120px",
        addFormOrder: 11,
        editFormOrder: 11,
        derivedValue: "phone=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "phone",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        fieldName: "phone",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "role",
        type: "dropDown",
        placeholder: "Role",
        label: "Permissioned Role",
        width: "130px",
        addFormOrder: 12,
        editFormOrder: 12,
        derivedValue: "role=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "role",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        options: [
          { label: "Staff", value: "Staff", color: "primary" },
        ],
        fieldType: "dropDown",
        dependent: [],
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        disabled: true,
        show: true,
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: true,
        isEditFormHidden: true,
      },
      {
        name: "updated",
        type: "date",
        placeholder: "Updated",
        label: "Updated",
        width: 90,
        derivedValue: "updated=undefined",
        actions: [],
        actionsNumber: [],
        id: "updated",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        disabled: true,
        show: true,
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: true,
        isEditFormHidden: true,
      },
    ];
  };

  const submit = async (item) => {
    setIsOpenFormModal(true);
    // await this.formModalRef.getRowData(item, 'edit');
  };
  const getMobileTableFields = () => {
    let data = [
      {
        textAlign: "center",
        width: 47,
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "firstName",
        type: "text",
        placeholder: "First Name",
        label: "First Name",
        width: 110,
        addFormOrder: 1,
        editFormOrder: 1,
        header: "First Name",
        derivedValue: "firstName=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        id: "firstName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: true,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: false,
        field: "firstName",
        showOrHideFields: [],
        fieldName: "firstName",
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
      },
      {
        name: "lastName",
        type: "text",
        placeholder: "Last Name",
        label: "Last Name",
        width: "130px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Last Name",
        derivedValue: "lastName=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "lastName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: false,
        field: "lastName",
        showOrHideFields: [],
        fieldName: "lastName",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "name",
        type: "derivedFields",
        placeholder: "Name",
        label: "Name",
        width: "120px",
        addFormOrder: 8,
        editFormOrder: 8,
        stringType: "string",
        header: "Name",
        derivedValue: "name=firstName+lastName",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: ["firstName", "lastName"],
        actionsNumber: [],
        id: "name",
        displayinaddForm: false,
        displayineditForm: false,
        displayinregisterForm: false,
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "name",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "email",
        type: "email",
        placeholder: "Email",
        label: "Email",
        width: "150px",
        addFormOrder: 10,
        editFormOrder: 10,
        header: "Email",
        derivedValue: "email=email=undefined",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "email",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "email",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "facilities",
        type: "relateAutoComplete",
        placeholder: "Facilities",
        label: "Facilities",
        width: "150px",
        addFormOrder: 13,
        editFormOrder: 13,
        header: "Facilities",
        derivedValue: "facilities=facilities=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "facilities",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: "Facilities",
        searchField: "facilityName",
        fieldType: "relateAutoComplete",
        populteFields: [],
        displayFields: [],
        controllerName: "Facility",
        searchApi: "facilities",
        isMultiple: true,
        textAlign: "Center",
        show: true,
        field: "facilities",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "phoneNumber",
        type: "number",
        placeholder: "Phone Number",
        label: "Phone Number",
        width: "120px",
        addFormOrder: 11,
        editFormOrder: 11,
        header: "Phone Number",
        derivedValue: "phoneNumber=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "phoneNumber",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "phoneNumber",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "permissionedRole",
        type: "dropDown",
        placeholder: "Permissioned Role",
        label: "Permissioned Role",
        width: "130px",
        addFormOrder: 12,
        editFormOrder: 12,
        header: "Permissioned Role",
        derivedValue: "permissionedRole=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "permissionedRole",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        options: [
          { label: "Admin", value: "Admin", color: "primary" },
          { label: "Staff", value: "Staff", color: "primary" },
        ],
        fieldType: "dropDown",
        dependent: [],
        textAlign: "Center",
        show: true,
        field: "permissionedRole",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "createdByName",
        type: "Text",
        placeholder: "Created By",
        label: "Created By",
        width: 120,
        header: "Created By",
        id: "createdByName",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: 1001,
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        field: "createdByName",
        mobile: true,
        filter: true,
        displayInSettings: true,
      },
      {
        name: "updatedByName",
        type: "Text",
        placeholder: "Updated By",
        label: "Updated By",
        width: 120,
        header: "Updated By",
        id: "updatedByName",
        displayinlist: "true",
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        filter: true,
        field: "updatedByName",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        header: "Created",
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: true,
        show: true,
        field: "created",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "updated",
        type: "date",
        placeholder: "Updated",
        label: "Updated",
        width: 90,
        header: "Updated",
        derivedValue: "updated=undefined",
        actions: [],
        actionsNumber: [],
        id: "updated",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: true,
        show: true,
        field: "updated",
        mobile: true,
        displayInSettings: true,
      },
      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
    ];
    return data;
  };
  const closeFormModal = async () => {
    setIsOpenFormModal(false);
  };
  // submit1 = item => {
  //   let x = facilityStaffsFields
  //   let objfacilityStaffs = {}

  //   objfacilityStaffs["_id"] = item[0]["_id"]
  //   for (let x2 of x) {
  //     objfacilityStaffs[x2] = item[0][x2]
  //   }
  //   let formFields = this.getFormFields()

  //   formFields = formFields.filter(y => x.includes(y.name))

  //   this.setState({
  //     openNewUserModal: true,
  //     item: objfacilityStaffs,
  //     newFormFields: formFields
  //   });
  // }

  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    window.location.reload();

    // if (type == "submit") {
    // type == "submit"
    //   ?
    // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
    // }

    // : null;
  };

  const saveDataToServer = async (item, field, value) => {
    let body = item[0];
    body[field] = value;
    let userBody = Object.assign({}, body);
    // this.setState({
    //   isLoading: true
    // });
    if (body) {
      let method, apiUrl;
      method = "PUT";
      apiUrl = `${apiCalls["facilityStaffs"]}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          // let sessionexpired = await localStorage.getItem('sessionexpired')
          // if (sessionexpired === "true") {
          //   await this.setState({ sessionExpiryModal: true })
          // }
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, "success");
          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, "error");
          }
          // this.setState({
          //   isLoading: false
          // });
        })
        .catch((err) => {
          return err;
        });
    } else {
      return;
    }
  };

  return (
    <span>
      {
        <DataTables
          {...props}
          getTableFields={getTableFields}
          formFields={getFormFields}
          //
          addRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          editRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          deleteRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          viewRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          // globalSearch={'Display Name/Email'}
          // type='Facility Staffs'
          // apiUrl={apiCalls.Facility Staffs}
          // exportRequried={true}
          selectionMode={true}
          printRequried={false}
          actionsTypes={false}
          // [
          // {
          //   name: "Delete",
          //   options: [
          //     {
          //       label: "Delete",
          //       value: "Delete",
          //       show:
          //         rolePermission && rolePermission == "Edit" ? true : false,
          //       multiple: true,
          //     },
          //   ],
          // },

          // {
          //   'name': 'Block',
          //   "options": [
          //     { 'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
          //   ]
          // },
          // {
          //   'name': 'ResetPassword',
          //   "options": [
          //     { 'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
          //   ]
          // },
          // {
          //   'name': 'Submit',
          //   'action': this.submit,
          //   "options": [
          //     { 'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
          //   ]
          // },
          // {
          //   name: "newModel",
          //   action: this.submit1,
          //   options: [
          //     { label: "newModel", value: "newModel", show: true, multiple: false }
          //   ]
          // }
          // ]}
          // addRequried={insertAdd}
          // editRequired={true}
          // deleteRequired={true}
          // viewRequired={true}
          settingsRequired={true}
          filterRequired={false}
          gridRequried={false}
          exportToCsv={false}
          refresh={true}
          getPagination={true}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          setData={setData}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          sampleFilePath={filePath["facilityStaffs"]}
          globalSearch={"Name / Email / Role"}
          type="Facility Staffs"
          headerName="Facility Staff"
          routeTo={"facilityStaffs"}
          displayViewOfForm="modal"
          sideFormLeftOrRight=""
          apiResponseKey={apiCalls["facilityStaffs"]}
          apiUrl={apiCalls["facilityStaffs"]}
          selectedId={params.id}
          companyId={companyId}
          customFormDataSet={customFormDataSet}
          customFormDataManuplate={customFormDataManuplate}
        />
      }
      {isOpenFormModal ? (
        <FormModal
          // onRef={(ref) => (this.formModalRef = ref)}
          formType="edit"
          openFormModal={isOpenFormModal}
          formFields={formFields}
        />
      ) : null}
      {openNewUserModal ? (
        <NewUserModal
          openNewUserModal={openNewUserModal}
          cancelReset={cancelReset}
          item={item}
          newFormFields={newFormFields}
          recordId={item._id}
          entityType="facilityStaffs"
          apiUrl={apiCalls["facilityStaffs"]}
        />
      ) : null}
    </span>
  );
};

export default FacilityStaffs;
